import { Button, message } from 'antd';
import dayjs from 'dayjs';
import React, { useCallback } from 'react';

import { rowsToCsv, type PortfolioProjectRow } from '@/api/portfolio/api';
import { DownloadIcon as DownloadOutlined } from '@/icons';

export interface PortfolioExportButtonProps {
  rows: PortfolioProjectRow[];
  isDirectorOrHigher: boolean;
}

/** Exports the whole portfolio as a CSV download — ignores the UI's current filters. */
export const PortfolioExportButton: React.FC<PortfolioExportButtonProps> = ({
  rows,
  isDirectorOrHigher,
}) => {
  const handleExport = useCallback(() => {
    try {
      const csv = rowsToCsv(rows, isDirectorOrHigher);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `blend-portfolio-${dayjs().format('YYYY-MM-DD')}.csv`;
      document.body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      void message.error(error instanceof Error ? error.message : 'Export failed');
    }
  }, [rows, isDirectorOrHigher]);

  return (
    <Button icon={<DownloadOutlined />} onClick={handleExport}>
      Export
    </Button>
  );
};

export default PortfolioExportButton;
